
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/candidate-privacy",
      function () {
        return require("private-next-pages/candidate-privacy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/candidate-privacy"])
      });
    }
  